<template>
  <div>
    <!-- หน้ารอโหลด -->
    <div
      v-if="isLoading"
    >
      <div class="loading-spinner">
        <div class="dot" />
        <div class="dot" />
        <div class="dot" />
      </div>
    </div>

    <div v-else>
      <!-- ปุ่มเพื่ม -->
      <div
        v-if="!roles.includes('ADMIN')"
        class="btn-space"
      >
        <b-button
          variant="primary"
          @click="openAdminForm"
        >
          {{ $t('AddFix') }}
        </b-button>
      </div>

      <!-- ค้นหา -->
      <div class="search-filters">
        <b-form-group :label="$t('searchorder')">
          <b-form-input
            v-model="search.order"
            :placeholder="$t('placeholderOrderFix')"
          />
        </b-form-group>

        <b-form-group
          v-if="!roles.includes('USER')"
          :label="$t('searchUser')"
        >
          <b-form-input
            v-model="search.username"
            :placeholder="$t('user')"
          />
        </b-form-group>

        <b-form-group :label="$t('startDate')">
          <b-form-input
            v-model="search.startDate"
            type="date"
          />
        </b-form-group>

        <b-form-group :label="$t('endDate')">
          <b-form-input
            v-model="search.endDate"
            type="date"
          />
        </b-form-group>
        <b-button
          style="margin-top: 12px; background-color: #02a63e; color: white; border: none;"
          variant="text-warning"
          class="responsive-button"
          @click="searchFixes(1)"
        >
          <b-icon
            icon="search"
            aria-hidden="true"
          />
          {{ $t('search') }}
        </b-button>

      </div>

      <!--ปุ่มstatusid-->
      <div class="btn-space">
        <b-button
          :variant="activeButton === 'fixstatus' ? 'primary' : ''"
          :disabled="!isButtonEnabled"
          @click="handleButtonClick(1, 'fixstatus')"
        >
          {{ $t('fixstatus') }}
        </b-button>
        <b-button
          :variant="activeButton === 'fixing' ? 'primary' : ''"
          :disabled="!isButtonEnabled"
          @click="handleButtonClick(2, 'fixing')"
        >
          {{ $t('fixing') }}
        </b-button>
        <b-button
          :variant="activeButton === 'claim' ? 'primary' : ''"
          :disabled="!isButtonEnabled"
          @click="handleButtonClick(3, 'claim')"
        >
          {{ $t('claim') }}
        </b-button>
        <b-button
          :variant="activeButton === 'waitingApprove' ? 'primary' : ''"
          :disabled="!isButtonEnabled"
          @click="headApprovelButtonClick(0, 'waitingApprove')"
        >
          {{ $t('headcheck') }}
        </b-button>
        <b-button
          :variant="activeButton === 'specialStatus' ? 'primary' : ''"
          :disabled="!isButtonEnabled"
          @click="handleButtonClick(5, 'specialStatus')"
        >
          {{ $t('cancelSucc') }}
        </b-button>
      </div>

      <!-- ตารางซ่อม -->
      <div class="table-wrapper">
        <b-table
          v-if="!isLoading && totalFixes > 0"
          :items="fixes"
          :fields="fields"
          class="fix-table"
        >
          <template #cell(order)="data">
            {{ data.item.order || '' }}
          </template>
          <template #cell(timefix)="data">
            {{ new Date(data.item.timefix).toLocaleString('th-TH', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
            }) || '' }}
          </template>
          <template #cell(category)="data">
            {{ data.item.category.nameCate || '' }}
          </template>
          <template #cell(subcategory)="data">
            {{ data.item.subcategory.name || '' }}
          </template>
          <template #cell(location)="data">
            {{ data.item.location ? data.item.location.locationName : '' }}
          </template>
          <template #cell(user)="data">
            <b-button
              variant="link"
              @click="showEmployeeModal(data.item.user ? data.item.user.id : null)"
            >
              {{ data.item.user ? data.item.user.username : '' }}
            </b-button>
          </template>
          <template #cell(devicecategory)="data">
            {{ data.item.deviceCategory ? data.item.deviceCategory.name : '' }}
          </template>
          <template #cell(devicesubcategory)="data">
            <span>{{ data.item.deviceSubcategory ? data.item.deviceSubcategory.name : '' }}</span>
          </template>
          <template #cell(fixDetails)="data">
            <span>
              {{ data.item.fixDetails && Array.isArray(data.item.fixDetails) ? data.item.fixDetails.map(detail => detail.detail ? detail.detail.substring(0, 5) + (detail.detail.length > 5 ? '...' : '') : '').join(', ') : '' }}
            </span>
          </template>
          <template #cell(fixDetailsAdditional)="data">
            <span>
              {{ data.item.fixDetailsAdditional && Array.isArray(data.item.fixDetailsAdditional) ? data.item.fixDetailsAdditional.map(addDetail => addDetail.fixdetail ? addDetail.fixdetail.substring(0, 5) + (addDetail.fixdetail.length > 5 ? '...' : '') : '').join(', ') : '' }}
            </span>
          </template>
          <template #cell(operator)="data">
            {{ data.item.operator ? data.item.operator.substring(0, 5) + (data.item.operator.length > 5 ? '...' : '') : '' }}
          </template>
          <template #cell(status)="data">
            {{ data.item.status ? data.item.status.statusName : '' }}
          </template>
          <template #cell(actions)="data">
            <b-button
              class="b-btn"
              variant="primary"
              size="sm"
              @click="viewDetails(data.item)"
            >
              {{ $t('details') }}
            </b-button>

            <b-button
              v-if="!disEditAndDel(data.item)"
              class="b-btn"
              variant="danger"
              size="sm"
              @click="deleteFix(data.item.id)"
            >
              {{ $t('cancel') }}
            </b-button>

            <b-button
              v-if="data.item.status && (data.item.status.id === 6 || data.item.status.id === 5) && data.item.showEvaluationButton && userId == data.item.user.id"
              class="b-btn"
              variant="info"
              size="sm"
              @click="openEvaluationForm(data.item)"
            >
              ให้คะแนน
            </b-button>

          </template>
        </b-table>

        <div
          v-if="!isLoading && totalFixes === 0"
          class="text-center mt-3"
        >
          <p style="font-size: 28px; font-weight: bold;">
            {{ $t('nofix') }}
          </p>
        </div>
      </div>

      <!-- Default -->
      <div
        v-if="!isLoading && !isSearchActive && !isWaitingApprove && totalFixes > 0"
        class="d-flex justify-content-end mt-3"
      >
        <b-pagination
          :key="'normal'"
          v-model="currentPage"
          :total-rows="totalFixes"
          :per-page="itemsPerPage"
          class="mt-3"
          @change="handlePageChange"
        />
      </div>

      <!-- Search -->
      <div
        v-if="!isLoading && isSearchActive && totalFixes > 0"
        class="d-flex justify-content-end mt-3"
      >
        <b-pagination
          :key="'search'"
          v-model="currentPage"
          :total-rows="totalFixes"
          :per-page="itemsPerPage"
          class="mt-3"
          @change="handlePageChangesearch"
        />
      </div>

      <!-- Waiting Approve -->
      <div
        v-if="!isLoading && isWaitingApprove && totalFixes > 0"
        class="d-flex justify-content-end mt-3"
      >
        <b-pagination
          :key="'waiting'"
          v-model="currentPage"
          :total-rows="totalFixes"
          :per-page="itemsPerPage"
          class="mt-3"
          @change="handlePageChangewaitingApprove"
        />
      </div>

      <!-- model  ตารางซ่อม -->
      <b-modal
        v-model="showForm"
        :title="$t('fixedit')"
        class="custom-modal"
        size="xl"
        hide-footer
        @hidden="clearSelectedFix"
      >
        <JobRequestForm
          :fix="selectedFix"
          :categories="categories"
          :devicecategories="devicecategories"
          :users="users"
          :locations="locations"
          @fix-saved="handleFixSaved"
          @close="showForm = false"
        />
      </b-modal>

      <b-modal
        v-model="showCancelModal"
        :title="$t('fixcancel')"
        hide-footer
        @hidden="clearCancelDetails"
      >
        <div>
          <b-form-group :label="$t('fixcancelDetails')">
            <b-form-textarea
              v-model="form.cancelDetails"
              :placeholder="$t('fixcancelDetailsinput')"
              rows="3"
              maxlength="150"
              required
              @input="checkLengthcancelDetails"
            />
            <small class="form-text text-muted">{{ form.cancelDetails.length }}/150 {{ $t('text') }}</small>
            <b-alert
              v-if="lengthcancelDetails"
              variant="danger"
              show
            >
              {{ $t('text150') }}
            </b-alert>
          </b-form-group>
          <b-button
            variant="danger"
            @click="confirmCancel"
          >
            {{ $t('cancelconfirm') }}
          </b-button>
          <b-button
            variant="secondary"
            class="ml-1"
            @click="showCancelModal = false"
          >
            {{ $t('cancel') }}
          </b-button>
        </div>
      </b-modal>

      <b-modal
        v-model="showEvaluationModal"
        :title="$t('rate')"
        hide-footer
      >
        <div>
          <b-form-group
            :label="$t('ratescore')"
            required
          >
            <b-form-select
              v-model="form.rate"
              :options="rateOptions"
            />
          </b-form-group>
          <b-form-group
            :label="$t('comment')"
            required
          >
            <b-form-textarea
              v-model="form.surveyDetails"
              :placeholder="$t('commentInput')"
              maxlength="150"
              rows="3"
              @input="checkLengthsurvey"
            />
            <small class="form-text text-muted">{{ form.surveyDetails.length }}/150 {{ $t('text') }}</small>
            <b-alert
              v-if="lengthsurveyDetails"
              variant="danger"
              show
            >
              {{ $t('text150') }}
            </b-alert>
          </b-form-group>
          <b-button
            variant="primary"
            @click="submitEvaluation"
          >
            {{ $t('sendcomment') }}
          </b-button>
          <b-button
            variant="secondary"
            class="ml-1"
            @click="showEvaluationModal = false"
          >
            {{ $t('cancel') }}
          </b-button>

        </div>
      </b-modal>

      <b-modal
        v-model="showThankYouModal"
        :title="$t('thankForhelp')"
        hide-footer
        @hidden="showThankYouModal = false"
      >
        <div>
          <p>{{ $t('thankForhelpText') }}</p>
          <b-button
            variant="primary"
            @click="showThankYouModal = false"
          >
            {{ $t('close') }}
          </b-button>
        </div>
      </b-modal>

      <!--model user-->
      <EmployeeModal
        :show="modalShowfix"
        :employee="selectedEmployee"
        @close="modalShowfix = false"
      />

      <!--model device-->
      <div
        v-if="isLoadingDeviceDetails"
        class="overlay"
      >
        <div class="loading-container">
          <b-spinner
            label="Loading..."
            class="spinner"
          />
          <p class="loading-text">
            {{ $t('loading') }}
          </p>
        </div>
      </div>
      <DeviceModel
        v-if="localShowModal"
        :local-show-modal="localShowModal"
        :warranty="warrantyData"
        :hardware="deviceHardwareList"
        :fixhistory="fixhistoryList"
        :expensefix="expensefixList"
        :spare="SpareListDevice"
        :devicehistory="devicehistoryList"
        :pmhistory="pmhistoryList"
        :details="selectedDevice || {}"
        @close="handleCloseModal"
      />

      <!-- Details Modal -->
      <div
        v-if="isLoadingViewDetails"
        class="overlay"
      >
        <div class="loading-container">
          <b-spinner
            label="Loading..."
            class="spinner"
          />
          <p class="loading-text">
            {{ $t('loading') }}
          </p>
        </div>
      </div>
      <DetailsModal
        v-if="!isLoadingViewDetails"
        :show="showDetailsModal"
        :expense="expense"
        :fix="selectedFix"
        :spare-list="spareList"
        @close="showDetailsModal = false"
        @refresh="handleRefresh"
      />
    </div>
  </div>
</template>

<script>
import { getRolesFromToken } from '@/services/JwtDecoder'
import apiAdmin from '@/services/admin'
import apiSetting from '@/services/Setting'
import apiMst from '@/services/masterDate'
import apiAuth from '@/services/auth'
import JobRequestForm from './JobRequestForm.vue'
import DetailsModal from '../AdminReviwer/DetailsModal.vue'
import EmployeeModal from '../AdminReviwer/EmployeeModel_fix.vue'
import DeviceModel from '../MasterData/DeviceModel.vue'

export default {
  components: {
    JobRequestForm,
    DetailsModal,
    EmployeeModal,
    DeviceModel,
  },
  data() {
    return {
      fixes: [],
      roles: [],
      categories: [],
      devicecategories: [],
      users: [],
      devices: [],
      search: {
        order: '',
        username: '',
        startDate: '',
        endDate: '',
      },
      showCancelModal: false,
      form: {
        cancelDetails: '',
        rate: null,
        surveyDetails: '',
      },
      isLoading: true,
      showForm: false,
      expense: [],
      showThankYouModal: false,
      evaluationSubmitted: false,
      showDetailsModal: false,
      selectedFix: {},
      imageUrls: [],
      errorMessage: '',
      showDeleteConfirm: false,
      spareList: [],
      SpareListDevice: [],
      filterMode: 'fixstatus',
      showEvaluationModal: false,
      rateOptions: [1, 2, 3, 4, 5].map(value => ({ value, text: value.toString() })),
      modalShowfix: false,
      modalShowdevice: false,
      selectedEmployee: {},
      localShowModal: false,
      selectedDevice: {},
      warrantyData: {},
      deviceHardwareList: [],
      isButtonEnabled: true,
      activeButton: 'fixstatus',
      currentPage: 1,
      itemsPerPage: 5,
      selectedStatusId: 1,
      totalFixes: 0,
      totalPages: 0,
      filteredFixes: [],
      isLoadingViewDetails: false,
      isLoadingDeviceDetails: false,
      fixhistoryList: [],
      expensefixList: [],
      devicehistoryList: [],
      pmhistoryList: [],
      lengthcancelDetails: false,
      lengthsurveyDetails: false,
      isSearchActive: false,
      locations: [],
      isWaitingApprove: false,
    }
  },
  computed: {
    userId() {
      console.log('id', this.$store.getters.userId)
      return this.$store.getters.userId
    },
    currentStatusId() {
      console.log('Current statusId from Vuex:', this.$store.state.statusId)
      return this.$store.state.statusId // เข้าถึง statusId จาก store
    },
    fields() {
      return [
        { key: 'order', label: this.$t('placeholderOrderFix'), sortable: true },
        { key: 'timefix', label: this.$t('fixDate'), sortable: true },
        { key: 'category', label: this.$t('cate'), sortable: true },
        { key: 'subcategory', label: this.$t('subcate'), sortable: true },
        { key: 'location', label: this.$t('locationname'), sortable: true },
		{
          key: 'sn', label: this.$t('sn'), sortable: true, thClass: 'text-center',
        },
        { key: 'user', label: this.$t('user'), sortable: true },
        { key: 'fixDetails', label: this.$t('fixDetails'), sortable: true },
        { key: 'fixDetailsAdditional', label: this.$t('problem'), sortable: true },
        { key: 'operator', label: this.$t('operator'), sortable: true },
        { key: 'status', label: this.$t('status'), sortable: true },
        { key: 'actions', label: this.$t('management') },
      ]
    },
  },

  watch: {
    currentStatusId(newVal) {
      console.log('Current statusId changed:', newVal)
      if (newVal !== null) {
        this.refreshFixes(newVal) // เรียกใช้งาน refreshFixes เมื่อ statusId เปลี่ยน
      }
    },
  },
  async mounted() {
    this.accessToken = localStorage.getItem('accessToken')
    this.roles = getRolesFromToken(this.accessToken)
    this.dept = JSON.parse(localStorage.getItem('dept'))
    this.orderId = this.$route.params.orderId
    if (this.orderId) {
      this.ShowbyOrder()
    } else {
      await this.loadData()
    }
  },
  created() {
    this.fetchLocations()
  },

  methods: {

    async loadData() {
      await Promise.all([this.fetchFixes(), this.fetchCategories(), this.fetchDeviceCategories(), this.fetchDevices()])
    },

    handleError(message, error) {
      console.error(message, error)
      this.errorMessage = message
    },

    async handlePageChange(page) {
      this.localShowModal = false
      this.currentPage = page
      await this.fetchFixes(this.currentPage)
    },

    async handlePageChangesearch(page) {
      this.localShowModal = false
      this.currentPage = page
      await this.searchFixes(this.currentPage)
    },

    async handlePageChangewaitingApprove(page) {
      this.currentPage = page
      await this.fetchFixesheadApprove(this.currentPage)
    },

    disEditAndDel(item) {
      return this.roles.includes('ADMIN') || this.roles.includes('APPROVER') || !(item.status && item.status.id === 1)
    },

    async showEmployeeModal(userId) {
      try {
        const response = await apiAuth.get(`auth/showbyid/${userId}`)
        console.log(response)
        this.selectedEmployee = response.data
        this.modalShowfix = true
      } catch (error) {
        console.error('Error fetching employee data:', error)
      }
    },

    async showDeviceModal(deviceId) {
      console.log('Device ID sent to API:', deviceId)

      this.isLoadingDeviceDetails = true

      try {
        const [response, hardwareResponse, warrantyResponse, fixhistoryRes, expenseHisRes, deviceHistoryRes, spareListRes, pmhistoryRes] = await Promise.allSettled([
          apiMst.get(`/deviceListId/${deviceId}`),
          apiMst.get(`/devicehardwareByDeviceId/${deviceId}`),
          apiMst.get(`/warrantyByDeviceId/${deviceId}`),
          apiAdmin.get(`/fixgetdevice/${deviceId}`),
          apiAdmin.get(`/expensefixList/device/${deviceId}`),
          apiAdmin.get(`/deviceUseHistoryGet/${deviceId}`),
          apiAdmin.get(`/sparelistByDevice/${deviceId}`),
          apiAuth.get(`/calendar/getdeviceCalendar?deviceId=${deviceId}`),
        ])

        // ดึงข้อมูลจากผลลัพธ์
        this.selectedDevice = response.status === 'fulfilled' ? response.value.data : {}
        this.deviceHardwareList = hardwareResponse.status === 'fulfilled' ? hardwareResponse.value.data || [] : []
        this.warrantyData = warrantyResponse.status === 'fulfilled' ? warrantyResponse.value.data || [] : []
        this.fixhistoryList = fixhistoryRes.status === 'fulfilled' ? fixhistoryRes.value.data || [] : []
        this.expensefixList = expenseHisRes.status === 'fulfilled' ? expenseHisRes.value.data || [] : []
        this.devicehistoryList = deviceHistoryRes.status === 'fulfilled' ? deviceHistoryRes.value.data || [] : []
        this.pmhistoryList = pmhistoryRes.status === 'fulfilled' ? pmhistoryRes.value.data || [] : []

        if (spareListRes.status === 'fulfilled') {
          const spareData = Array.isArray(spareListRes.value.data) ? spareListRes.value.data : []
          this.SpareListDevice = spareData.map((spare, index) => ({
            id: spare.id,
            orderlist: index + 1,
            list: spare.spList || '',
            purchase: spare.spPurchase || '',
            quantity: spare.spQuantity || '',
            cost: spare.spCost || 0,
            source: spare.spSource || '',
            detail: spare.spDetail || '',
          }))
        } else {
          this.SpareListDevice = []
        }

        this.$nextTick(() => {
          this.localShowModal = true
        })
      } catch (error) {
        console.error('Error fetching device details:', error)
      } finally {
        this.isLoadingDeviceDetails = false
      }
    },

    handleButtonClick(statusId, buttonType) {
      this.isWaitingApprove = false
      this.selectedStatusId = statusId
      this.activeButton = buttonType
      this.currentPage = 1
      this.localShowModal = false
      this.fetchFixes()
    },

    headApprovelButtonClick(statusId, buttonType) {
      this.selectedStatusId = statusId
      this.activeButton = buttonType
      this.currentPage = 1
      this.fetchFixesheadApprove()
    },

    async searchFixes(page = 1) {
      this.isLoading = true
      this.isWaitingApprove = false
      try {
        if (!this.search.order && !this.search.username && !this.search.startDate && !this.search.endDate) {
          if (this.fixes.length === 0 || page === 1) {
            this.isSearchActive = false
            this.selectedStatusId = 1
            this.activeButton = this.getButtonType(1)
            this.currentPage = 1
            await this.fetchFixes(1)
            return
          }
        }
        this.isSearchActive = true
        this.currentPage = page

        const params = {
          order: this.search.order,
          username: this.search.username,
          startDate: this.search.startDate,
          endDate: this.search.endDate,
          page: page - 1,
          size: this.itemsPerPage,
        }

        let response

        if (this.roles.includes('APPROVER')) {
          response = await apiAdmin.get(`/fixgetdeptId/search/${this.dept.id}`, { params })
        } else {
          response = await apiAdmin.get(`/fixgetuserId/search/${this.$store.getters.userId}`, { params })
        }

        this.fixes = await Promise.all(response.data.content.map(async fix => {
          const detailsResponse = await apiAdmin.get(`/details/${fix.id}`)
          const additionalResponse = await apiAdmin.get(`/fixdetails/${fix.id}`)
          const solutionResponse = await apiAdmin.get(`/fixsolution/${fix.id}`)
          const showEvaluationButton = await this.checkSurveyStatus(fix.id)
          return {
            ...fix,
            showEvaluationButton,
            fixDetails: detailsResponse.data || [],
            fixDetailsAdditional: additionalResponse.data || [],
            fixsolution: solutionResponse.data || [],
          }
        }))
        this.totalFixes = response.data.totalElements
        this.totalPages = response.data.totalPages

        if (this.totalFixes === 0) {
          this.errorMessage = 'ไม่พบข้อมูลที่ค้นหา'
          this.currentPage = 1
          page = 1
        } else {
          this.errorMessage = ''
        }

        this.activeButton = null
      } catch (error) {
        console.error('Error fetching fixes:', error)
        this.fixes = []
        this.totalFixes = 0
        this.totalPages = 0
      } finally {
        this.isLoading = false
        this.localShowModal = false
      }
    },

    async fetchLocations() {
      try {
        const response = await apiMst.get('/location')
        this.locations = response.data || []
      } catch (error) {
        console.error('Error fetching locations:', error)
      }
    },

    async fetchFixes() {
      this.isLoading = true
      this.errorMessage = ''

      try {
        const params = {
          statusId: this.selectedStatusId,
          page: this.currentPage - 1,
          size: this.itemsPerPage,
        }

        let response

        // Check user roles to fetch the correct data
        if (this.roles.includes('ADMIN') || this.roles.includes('SYSTEM')) {
          response = await apiAdmin.get('/fix', { params })
        } else if (this.roles.includes('APPROVER')) {
          response = await apiAdmin.get(`/fixgetdeptId/${this.dept.id}`, { params })
        } else {
          response = await apiAdmin.get(`/fixgetuserId/${this.$store.getters.userId}`, { params })
        }

        // แปลงข้อมูลการซ่อม
        this.fixes = await Promise.all(response.data.content.map(async fix => {
          const detailsResponse = await apiAdmin.get(`/details/${fix.id}`)
          const additionalResponse = await apiAdmin.get(`/fixdetails/${fix.id}`)
          const expenseResponse = await apiAdmin.get(`/expensefixList/${fix.id}`)
          const solutionResponse = await apiAdmin.get(`/fixsolution/${fix.id}`)
          const showEvaluationButton = await this.checkSurveyStatus(fix.id)

          return {
            ...fix,
            fixDetails: detailsResponse.data || [],
            fixDetailsAdditional: additionalResponse.data || [],
            fixsolution: solutionResponse.data || [],
            expense: expenseResponse.data || [],
            evaluationSubmitted: fix.evaluationSubmitted || false,
            showEvaluationButton,
          }
        }))

        this.sortFixes()

        // อัปเดตข้อมูลจำนวนทั้งหมดและจำนวนหน้า
        this.totalFixes = response.data.totalElements
        this.totalPages = response.data.totalPages

        console.log(this.fixes)
      } catch (error) {
        if (error.response && error.response.status === 404) {
          console.warn('ไม่มีข้อมูลรายการซ่อม')
          this.fixes = []
          this.totalFixes = 0
        } else {
          this.errorMessage = 'ไม่สามารถโหลดข้อมูลการซ่อมได้'
        }
      } finally {
        this.isLoading = false
        this.showCancelModal = false
        this.localShowModal = false
        this.showForm = false
      }
    },

    async fetchFixesheadApprove() {
      this.isLoading = true
      this.errorMessage = ''
      this.isWaitingApprove = true

      try {
        const params = {
          page: this.currentPage - 1,
          size: this.itemsPerPage,
        }

        let response

        if (this.roles.includes('ADMIN') || this.roles.includes('SYSTEM')) {
          response = await apiAdmin.get('/fix', { params })
        } else if (this.roles.includes('APPROVER')) {
          response = await apiAdmin.get(`/fixgetdeptIdHead/${this.dept.id}`, { params })
        } else {
          response = await apiAdmin.get(`/fixgetuserIdHead/${this.$store.getters.userId}`, { params })
        }

        // แปลงข้อมูลการซ่อม
        this.fixes = await Promise.all(response.data.content.map(async fix => {
          const detailsResponse = await apiAdmin.get(`/details/${fix.id}`)
          const additionalResponse = await apiAdmin.get(`/fixdetails/${fix.id}`)
          const expenseResponse = await apiAdmin.get(`/expensefixList/${fix.id}`)
          const solutionResponse = await apiAdmin.get(`/fixsolution/${fix.id}`)
          const showEvaluationButton = await this.checkSurveyStatus(fix.id)

          return {
            ...fix,
            fixDetails: detailsResponse.data || [],
            fixDetailsAdditional: additionalResponse.data || [],
            fixsolution: solutionResponse.data || [],
            expense: expenseResponse.data || [],
            evaluationSubmitted: fix.evaluationSubmitted || false,
            showEvaluationButton,
          }
        }))

        this.sortFixes()

        // อัปเดตข้อมูลจำนวนทั้งหมดและจำนวนหน้า
        this.totalFixes = response.data.totalElements
        this.totalPages = response.data.totalPages

        console.log(this.fixes)
      } catch (error) {
        if (error.response && error.response.status === 404) {
          console.warn('ไม่มีข้อมูลรายการซ่อม')
          this.fixes = []
          this.totalFixes = 0
        } else {
          this.errorMessage = 'ไม่สามารถโหลดข้อมูลการซ่อมได้'
        }
      } finally {
        this.isLoading = false
        this.showCancelModal = false
        this.localShowModal = false
        this.showForm = false
      }
    },

    refreshFixes(statusId) {
      this.selectedStatusId = statusId
      this.activeButton = this.getButtonType(statusId)
      this.currentPage = 1

      this.fetchFixes()
    },

    getButtonType(statusId) {
      switch (statusId) {
        case 1: return 'fixstatus'
        case 2: return 'fixing'
        case 3: return 'claim'
        case 4:
        case 5: return 'specialStatus' // Combine cases 4 and 5
        default: return null
      }
    },

    sortFixes() {
      this.fixes.sort((a, b) => b.order - a.order)
    },

    processFixes(data) {
      return Array.isArray(data) ? data.map(fix => ({
        ...fix,
        device: fix.device || { deviceName: '' },

      })) : []
    },

    async fetchCategories() {
      try {
        const response = await apiSetting.get('/cate')
        this.categories = response.data || []
      } catch (error) {
        this.errorMessage = 'ไม่สามารถโหลดหมวดหมู่ได้'
      }
    },

    async fetchDeviceCategories() {
      try {
        const response = await apiMst.get('/device')
        this.devicecategories = response.data || []
      } catch (error) {
        this.errorMessage = 'ไม่สามารถโหลดหมวดหมู่ได้'
      }
    },

    async fetchDevices() {
      try {
        const response = await apiMst.get('/deviceListAll')
        this.devices = response.data || []
        console.log(this.devices)
      } catch (error) {
        this.errorMessage = 'ไม่สามารถโหลดอุปกรณ์ได้'
      }
    },

    formatDate(dateString) {
      return new Date(dateString).toLocaleString('th-TH', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      }) || ''
    },
    editFix(fix) {
      this.selectedFix = {
        ...fix,
      }
      this.showForm = true
    },
    openAdminForm() {
      this.selectedFix = {
        order: '',
        timefix: '',
        category: { id: null, name: 'Select Category' },
        subcategory: { id: null, name: 'Select Subcategory' },
        device: { id: null, deviceName: 'Select Device' },
        user: { id: null, username: 'Select User' },
        detail: '',
        fixdetail: '',
        operator: '',
        status: '',
        roles: [],
        location: { id: null, locationName: 'Select Location' },
      }
      this.showForm = true
    },
    clearSelectedFix() {
      this.selectedFix = null
      this.imageUrls = []
      this.errorMessage = ''
    },
    async handleFixSaved() {
      await this.fetchFixes()
      this.showForm = false
      this.selectedFix = null
    },
    async viewDetails(fix) {
      this.selectedFix = { ...fix }
      this.isLoadingViewDetails = true
      this.showDetailsModal = true

      try {
        const spareList = await this.fetchSpareList(fix.id)
        console.log('Spare List:', spareList)

        if (spareList && spareList.length > 0) {
          this.spareList = spareList
        } else {
          this.spareList = []
        }

        const expense = await this.fetchExpense(fix.id)
        console.log('Expense:', expense)

        if (expense && Array.isArray(expense) && expense.length > 0) {
          this.expense = expense
        } else if (expense && expense.cost !== undefined) {
          this.expense = [expense]
        } else {
          this.expense = []
        }
      } catch (error) {
        console.error('Error loading data', error)
      } finally {
        this.isLoadingViewDetails = false
      }
    },

    async handleRefresh() {
      try {
        this.showDetailsModal = false
        await this.fetchFixes()
      } catch (error) {
        console.error('Error while refreshing:', error)
      }
    },

    deleteFix(id) {
      this.selectedFix = this.fixes.find(fix => fix.id === id)
      this.showCancelModal = true
    },
    async confirmCancel() {
      if (!this.selectedFix || !this.selectedFix.id) {
        this.errorMessage = 'ไม่สามารถลบการซ่อมได้: หมายเลขการซ่อมไม่ถูกต้อง'
        return
      }

      if (this.form.cancelDetails.trim() === '') {
        this.errorMessage = 'กรุณากรอกหมายเหตุในการยกเลิก'
        return
      }

      try {
        // Set the status to 5 when canceling a fix with statusId 6
        const fixData = {
          status: { id: this.selectedFix.status.id === 6 ? 5 : this.selectedFix.status.id },
        }

        await apiAdmin.put(`/updateCancelDetails/${this.selectedFix.id}`, { cancelDetails: this.form.cancelDetails })
        await apiAdmin.put(`/cancel/${this.selectedFix.id}`, fixData)

        await this.fetchFixes()
        this.clearCancelDetails()

        this.showCancelModal = false
        this.localShowModal = false
      } catch (error) {
        this.errorMessage = 'เกิดข้อผิดพลาดในการลบการซ่อม'
      }
    },

    clearCancelDetails() {
      this.form.cancelDetails = ''
    },

    // เเบบประเมิณ
    openEvaluationForm(fix) {
      this.selectedFix = { ...fix }
      if (!this.showThankYouModal) {
        this.showEvaluationModal = true
      }
    },
    async checkSurveyStatus(fixId) {
      try {
        const response = await apiAdmin.get(`/checkSurvey/${fixId}`)
        return response.data
      } catch (error) {
        console.error('Error checking survey status:', error)
        return false
      }
    },

    async submitEvaluation() {
      if (!this.selectedFix || !this.selectedFix.id) {
        this.errorMessage = 'ไม่สามารถส่งแบบประเมินได้: ข้อมูลการซ่อมไม่ถูกต้อง'
        return
      }

      try {
        console.log('Sending evaluation:', {
          rate: this.form.rate,
          surveyDetails: this.form.surveyDetails,
        })

        await apiAdmin.put(`/Addsurvay/${this.selectedFix.id}`, {
          rate: this.form.rate,
          surveyDetails: this.form.surveyDetails,
        })

        // เปลี่ยนสถานะเฉพาะ fix ที่ถูกส่ง
        const fixIndex = this.fixes.findIndex(fix => fix.id === this.selectedFix.id)
        if (fixIndex !== -1) {
          this.fixes[fixIndex].evaluationSubmitted = true
        }
        this.showEvaluationModal = false

        await this.fetchFixes()
        this.showThankYouModal = true
        this.form.rate = null
        this.form.surveyDetails = ''
      } catch (error) {
        console.error('Error submitting evaluation:', error)
        this.errorMessage = 'เกิดข้อผิดพลาดในการส่งแบบประเมิน'
      }
    },

    // fetch spare expense
    async fetchExpense(fixId) {
      try {
        const response = await apiAdmin.get(`/expensefixList/${fixId}`)
        console.log('expense', response.data)

        this.expense = Array.isArray(response.data) ? response.data : [response.data]

        if (this.expense.length === 0) {
          console.warn('Warning: No expense data found.')
        }
        return this.expense
      } catch (error) {
        console.error('Error fetching expense data:', error)
        this.expense = []
        return []
      }
    },

    async fetchSpareList(fixId) {
      try {
        const response = await apiAdmin.get(`/sparelistByFixId/${fixId}`)
        this.spareList = Array.isArray(response.data) ? response.data : []

        if (this.spareList.length === 0) {
          console.warn('Warning: No spare list found.')
        }

        return this.spareList
      } catch (error) {
        console.error('Error fetching spare list:', error)
        this.spareList = []
        return []
      }
    },

    async ShowbyOrder(page = 1) {
      this.isLoading = true
      try {
        this.isSearchActive = false
        this.activeButton = null
        this.currentPage = page

        const response = await apiAdmin.get(`/fixgetuserId/search/${this.$store.getters.userId}?order=${this.orderId}&page=0&size=5`)

        if (response.data.content.length === 0) {
          this.errorMessage = 'ไม่พบข้อมูลใบแจ้งซ่อมนี้'
          this.fixes = []
          this.totalFixes = 0
          this.totalPages = 0
          return
        }

        this.fixes = await Promise.all(response.data.content.map(async fix => {
          try {
            const [detailsResponse, additionalResponse, solutionResponse, showEvaluationButton] = await Promise.all([
              apiAdmin.get(`/details/${fix.id}`),
              apiAdmin.get(`/fixdetails/${fix.id}`),
              apiAdmin.get(`/fixsolution/${fix.id}`),
              this.checkSurveyStatus(fix.id),
            ])

            return {
              ...fix,
              fixDetails: detailsResponse.data || [],
              fixDetailsAdditional: additionalResponse.data || [],
              fixsolution: solutionResponse.data || [],
              showEvaluationButton,
            }
          } catch (error) {
            console.error(`Error fetching details for fix ${fix.id}:`, error)
            return {
              ...fix,
              fixDetails: [],
              fixDetailsAdditional: [],
              fixsolution: [],
              showEvaluationButton: false,
            }
          }
        }))

        this.totalFixes = response.data.totalElements
        this.totalPages = response.data.totalPages

        this.errorMessage = `แสดงรายละเอียดใบแจ้งซ่อมหมายเลข: ${this.orderId}`
      } catch (error) {
        console.error('Error fetching fixes by order:', error)
        this.errorMessage = 'เกิดข้อผิดพลาดในการดึงข้อมูลใบแจ้งซ่อม'
        this.fixes = []
        this.totalFixes = 0
        this.totalPages = 0
      } finally {
        this.isLoading = false
      }
    },

    async mounted() {
      const fixId = this.getFixId() // ฟังก์ชันหรือค่าที่คุณใช้เพื่อดึง fixId
      await this.fetchSpareList(fixId)
      await this.fetchExpense(fixId)
    },

    handleShowModal(deviceDetails) {
      this.deviceDetails = deviceDetails.details
      this.deviceWarranty = deviceDetails.warranty
      this.deviceHardware = deviceDetails.hardware
      this.localShowModal = true
    },
    handleCloseModal() {
      this.localShowModal = false
      this.selectedDevice = {}
    },

    checkLengthcancelDetails() {
      if (this.form.cancelDetails.length >= 150) {
        this.lengthcancelDetails = true
        this.form.cancelDetails = this.form.cancelDetails.slice(0, 150)
      } else {
        this.lengthcancelDetails = false
      }
    },

    checkLengthsurvey() {
      if (this.form.surveyDetails.length >= 150) {
        this.lengthsurveyDetails = true
        this.form.surveyDetails = this.form.surveyDetails.slice(0, 150)
      } else {
        this.lengthsurveyDetails = false
      }
    },
  },
}
</script>

<style scoped>
.listdata {
  font-size: x-small;
  margin: 0.5%;
}

.container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.search-filters {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.fix-table tr {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #ccc;
    margin-bottom: 10px;
}

.fix-table td {
    display: flex;
    justify-content: space-between;
    border: none;
    padding: 10px;
    background-color: #f9f9f9;
}

.fix-table td::before {
    content: attr(data-label);
    font-weight: bold;
}

.table-wrapper {
  overflow-x: auto;
  width: 100%;
}

.fix-table {
  width: 100%;
  border-collapse: collapse;
  white-space: nowrap;
}

.fix-table td,
.fix-table th {
  font-size: small;
  padding: 8px;
  text-align: left;
}

.custom-modal .modal-dialog {
  width: 80vw;
  height: auto;
  max-width: 900px;
}

.custom-modal .modal-content {
  padding: 20px;
  border-radius: 10px;
}

.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.loading-text {
  margin-top: 10px;
  font-size: 16px;
}

.dot {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #5496ec;
  animation: bounce 0.6s infinite alternate;
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounce {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-20px);
  }
}

.b-btn {
  margin-right: 10px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* สีพื้นหลังขุ่น */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* ทำให้ overlay อยู่เหนือโมเดล */
}

.b-spinner {
  color: white;
}

.loading-container {
  text-align: center;
  color: #fff;
}

.clickable-icon {
  cursor: pointer; /* เปลี่ยนเคอร์เซอร์เป็นมือเมื่อชี้ที่ไอคอน */
  margin-right: 10px; /* เพิ่มระยะห่างระหว่างไอคอน */
  margin-bottom: 5px;
}
.icon-large {
  font-size: 24px; /* กำหนดขนาดไอคอน (ปรับตามต้องการ) */
}

@media (max-width: 768px) {
  .custom-modal .modal-dialog {
    width: 90vw;
  }
}

.fix-table thead {
    display: none; /* ซ่อนหัวตาราง */
}

.custom-modal .modal-dialog {
    width: 100vw; /* ทำให้ modal เต็มความกว้าง */
    height: auto; /* ปรับความสูงตามเนื้อหา */
    max-width: none; /* ไม่จำกัดความกว้างสูงสุด */
}

@media (max-width: 768px) {
  .fix-table {
    display: block; /* เปลี่ยนตารางให้เป็น block */
    overflow-y: auto; /* เพิ่มแถบเลื่อนแนวนอน */
  }
}
.btn-space {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  flex-wrap: wrap; /* เพื่อให้ปุ่มเลื่อนลงมาในกรณีที่พื้นที่ไม่พอ */
}

/* สำหรับมือถือ */
@media (max-width: 360px) {
  .btn-space {
    justify-content: center; /* จัดตำแหน่งปุ่มไปที่กลาง */
  }

  .btn-space b-button {
    flex: 1 1 100%; /* ทำให้ปุ่มเต็มความกว้าง */
    margin-bottom: 0.5rem; /* เว้นระยะห่างระหว่างปุ่ม */
  }
  .listdata {
    font-size: 0.9rem; /* ลดขนาดฟอนต์ให้เหมาะสมกับหน้าจอเล็ก */
  }

  .search-filters input {
    font-size: 14px; /* ปรับขนาดฟอนต์ของ input ให้อ่านง่าย */
    width: 100%; /* ให้ input ใช้พื้นที่เต็มความกว้าง */
    padding: 8px; /* เพิ่มระยะห่างภายใน input */
  }

  .search-filters label {
    font-size: 14px;
  }

  .custom-modal .modal-dialog {
        width: 95vw; /* ปรับความกว้างของ modal สำหรับมือถือ */
  }

  .fix-table td {
        flex-direction: column; /* ทำให้เซลล์แสดงผลในแนวตั้ง */
        padding: 8px; /* ลดระยะห่างในเซลล์ */
  }
}

</style>
